import { render, staticRenderFns } from "./CustomerNotificationListItem.vue?vue&type=template&id=2549679b&scoped=true&"
import script from "./CustomerNotificationListItem.vue?vue&type=script&lang=ts&"
export * from "./CustomerNotificationListItem.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerNotificationListItem.vue?vue&type=style&index=0&id=2549679b&lang=scss&scoped=true&"
import style1 from "./CustomerNotificationListItem.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2549679b",
  null
  
)

export default component.exports